<template>
	<div class="drawer">
		<el-drawer size="650px" :visible.sync="drawerStatus" @close='close' :append-to-body="true" :title="'申请单详情'" :wrapperClosable="false" >
			<el-form :inline="true" class="form">
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="申请日期:" :label-width="formLabelWidth" >
							{{detail.createOperationInfo&&detail.createOperationInfo.operationTime}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="申请门店:" :label-width="formLabelWidth" >
							{{detail.shopInfo&&detail.shopInfo.shopName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="申请人:" :label-width="formLabelWidth" >
							{{detail.createOperationInfo&&detail.createOperationInfo.userName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="申请状态:" :label-width="formLabelWidth" >
							{{detail.state&&detail.state.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="名称:" :label-width="formLabelWidth" >
							{{detail.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="规格:" :label-width="formLabelWidth" >
							{{detail.skuName}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="类型:" :label-width="formLabelWidth" >
							{{detail.type&&detail.type.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="数量:" :label-width="formLabelWidth" >
							{{detail.count}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="价格:" :label-width="formLabelWidth" >
							{{detail.money}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="描述:" :label-width="formLabelWidth">
							{{detail.remarks}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="图片:" :label-width="formLabelWidth">
							<div class="imgView">
								<div v-for="(item,index) in detail.images" :key="index" class="imgItem">
									<el-image :src="item" :preview-src-list="[item]"></el-image>
								</div>
							</div>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row style="padding:0 10px;float: none;">
					<el-col :span="20" :offset="1">
						<el-form-item label="附件:" :label-width="formLabelWidth">
							
						</el-form-item>
					</el-col>
				</el-row> -->
			</el-form>
			<div style="height: 40px;width:100%;"></div>
			<div class="btnBox">
				<div class="btnItem" @click="close">取消</div>
				<div class="btnItem submit" @click="close">确定</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				drawerStatus:false,
				formLabelWidth:'80px',
				
				detail:{},
			}
		},
		computed:{
			
		},
		props:{
			id:{
				default:''
			}
		},
		mounted(){
			this.$nextTick(()=>{
				this.drawerStatus = true;
			})
			this.$http.get(process.env.VUE_APP_zichan+'/api/AssetsRequest/detail', {
				id:this.id
			}).then(res => {
				if (res.code == 0) {
					this.detail = res.data
				}
			})
		},
		methods: {
			close(){
				this.$emit('submit',{type:'close'})
			},
		}
	}
</script>

<style scoped lang="scss">
	.drawer{
		width:0;
		padding:0 0 0 0;
		::v-deep.el-drawer{
			.form{
				::v-deep .el-form-item{
					margin:5px 0;
					
				}
				
			}
		}
		
	}
	.imgView{
		flex: 1;
		.imgItem{
			position: relative;
			width: 80px; 
			height: 80px;
			margin-right:20px;
			margin-bottom: 10px;
			float: left;
			img{
				width: 100%;
				height: 100%;
			}
			.closeBtn{
				display: block;
				color: red;
				position: absolute;
				top: -10px;
				right: -10px;
				font-size: 20px;
				z-index: 5;
			}
		}
	}
	.btnBox{
		width:100%;font-size: 14px;color:#fff;line-height: 40px;display: flex;position: absolute;bottom: 0;z-index: 10;
		.btnItem{
			text-align: center;width:100%;background-color: #D6D6D6;cursor: pointer;
			&.submit{
				background-color: $mainColor;
			}
		}
	}
</style>
